<script lang="ts">
  import Modal from '$lib/modals/Modal.svelte';
  import { storeCartError } from '$lib/js/stores';
	import { afterNavigate } from '$app/navigation';

  afterNavigate(() => {
    $storeCartError = ''
  })
</script>


<Modal on:close="{() => $storeCartError = ''}" type="adapted">
  <div class="error-modal">
    <div class="error-modal__inner">
      <h2 class="title">{"Se ha producido un error"}</h2>
      <p>{@html $storeCartError}</p>
    </div>
  </div>
</Modal>


<style lang="scss">
  .error-modal {
    max-width: 340px;
    
    h2 {
      margin-right: 60px;
      font-size: 18px;
    }
  }
</style>